<div bdFxLayout="row wrap" class="ps-container">
    <div bdFxLayoutAlign="center center" *ngIf="label && label != null"
         class="ps-label {{showValidation ? (isError ? 'ps-error' : 'ps-success') : ''}}">
        {{label}}</div>



    <div bdFxFlex="1 1 100%" class="ps-input-container">
        <input *ngIf="type === 'number' && !formatCurrency"  [id]="name" [disabled]="disabled"
               #inputRef
               (keyup)="this.value = minMax($event, this.value, minLength, maxLength)"
               (keypress)="numberOnly($event)"

               [ngClass]="{'clearable': (showClearIcon() && value) || name === 'totalMin' || name === 'totalMax','bold': boldType }"
               class="ps-value {{showValidation ? (isError ? 'ps-error' : 'ps-success') : ''}}" [(ngModel)]="value"

               [placeholder]="placeholder || ''" [mask]="maskValue" [dropSpecialCharacters]="false"
               (ngModelChange)="updateChanges()" />

        <input *ngIf="type === 'number' && formatCurrency" (keyup)="this.value = limitDecimals($event, this.value)"  [id]="name" [disabled]="disabled"

               #inputRef
               (keypress)="numberOnly($event)"

               [ngClass]="{'clearable': (showClearIcon() && value) || name === 'totalMin' || name === 'totalMax','bold': boldType }"
               class="ps-value {{showValidation ? (isError ? 'ps-error' : 'ps-success') : ''}}" [(ngModel)]="value"

               [placeholder]="placeholder || ''" [mask]="maskValue" [dropSpecialCharacters]="false"
               (ngModelChange)="updateChanges()" />

        <input *ngIf="type === 'text'" [disabled]="disabled" [id]="name"
               #inputRef
               [ngClass]="{'clearable': (showClearIcon() && value) || name === 'totalMin' || name === 'totalMax','bold': boldType, 'text-left': textAlignLeft }"
               class="ps-value {{showValidation ? (isError ? 'ps-error' : 'ps-success') : ''}}" [(ngModel)]="value"
               [placeholder]="placeholder || ''" [mask]="maskValue" [dropSpecialCharacters]="false"
               (ngModelChange)="updateChanges()" />

        <div *ngIf="showClearIcon() && value" bdFxLayoutAlign="center center" (click)="clear()"
             class="ps-clear {{showValidation ? (isError ? 'ps-error' : 'ps-success') : ''}}">
            <i class="fa fa-times-circle"></i>
        </div>
    </div>
</div>
